import { render, staticRenderFns } from "./CvaPresentation.vue?vue&type=template&id=a0b3704e&"
import script from "./CvaPresentation.js?vue&type=script&lang=js&"
export * from "./CvaPresentation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports